module.exports = __webpack_public_path__ + "img/lua.8ee812f0.png";